<template>
  <div class="page project-page">
    <div class="top project-top">
      <van-search
        v-model="filters.name"
        placeholder="搜索项目名称"
        shape="round"
        style="padding-bottom: 0"
        @input="onFilterNameInput"
        @clear="onFilterChange"
      />
      <div class="date-filter">
        <div class="date-row">
          <span class="date-label">中心</span>
          <span class="date-value date-value--wide" @click="openFilterDepartmentPicker">{{ filterDepartmentLabel || "全部中心" }}</span>
          <span
            v-if="filters.topDepartmentId !== null && filters.topDepartmentId !== undefined && filters.topDepartmentId !== ''"
            class="date-clear"
            @click="clearFilterDepartment"
          >
            清空
          </span>
        </div>
      </div>
      <div class="project-valid-tabs">
        <van-tabs v-model="validOnlyTab" swipeable @change="onValidOnlyTabChange">
          <van-tab v-for="tab in validOnlyTabs" :key="tab.value" :title="tab.label" :name="tab.value" />
        </van-tabs>
      </div>
    </div>

    <div class="list project-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="records-wrap">
          <van-empty v-if="!items.length && !loading" image="search" description="暂无项目" class="empty" />
          <div
            v-for="row in items"
            :key="row.id"
            :class="['card', 'record-card', 'record-accent-card', projectCardClass(row)]"
          >
            <div class="project-card-top">
              <span class="project-name">{{ row.name || row.projectName || "-" }}</span>
              <van-tag v-if="validityTagText(row)" :class="['project-valid-tag', validityTagClass(row)]">
                {{ validityTagText(row) }}
              </van-tag>
            </div>
            <div class="project-row">开始日期：{{ row.startDate || "-" }}</div>
            <div class="project-row">结束日期：{{ row.endDate || "-" }}</div>
            <div class="project-row">中心：{{ formatDepartmentNames(row) }}</div>
            <div v-if="(row.remark || '').trim()" class="project-row">备注：{{ row.remark }}</div>
            <div class="project-row project-row--meta">创建时间：{{ row.createTime || "-" }}</div>
            <div class="project-actions">
              <van-button plain hairline round size="small" class="project-op-btn project-op-btn--edit" @click="openEdit(row)">编辑</van-button>
              <van-button plain hairline round size="small" class="project-op-btn project-op-btn--delete" @click="onDelete(row)">删除</van-button>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <van-popup v-model="formPopup.show" position="bottom" round :style="{ height: '46vh' }">
      <div class="booking-popup-wrap popup-wrap">
        <div class="popup-head">
          <div class="popup-title">{{ formPopup.mode === "create" ? "新增项目" : "编辑项目" }}</div>
          <van-icon name="cross" class="popup-close" @click="formPopup.show = false" />
        </div>
        <div class="booking-popup-scroll popup-body">
          <van-field v-model.trim="formPopup.form.name" label="项目名称" placeholder="请输入项目名称" required />
          <van-field
            readonly
            clickable
            label="开始日期"
            :value="formPopup.form.startDate"
            placeholder="请选择开始日期"
            required
            @click="openDatePicker('startDate')"
          />
          <van-field
            readonly
            clickable
            label="结束日期"
            :value="formPopup.form.endDate"
            placeholder="请选择结束日期"
            required
            @click="openDatePicker('endDate')"
          />
          <van-field
            readonly
            clickable
            label="中心"
            :value="formDepartmentLabel"
            placeholder="请选择中心"
            required
            @click="openDepartmentPicker"
          />
          <van-field
            v-model.trim="formPopup.form.remark"
            label="备注"
            type="textarea"
            rows="1"
            autosize
            placeholder="选填"
          />
        </div>
        <div class="popup-actions">
          <van-button round block type="primary" class="theme-btn" :loading="formPopup.submitting" @click="submitForm">
            保存
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="departmentPicker.show" position="bottom" round :style="{ height: '60vh' }">
      <div class="owner-dept-popup">
        <div class="popup-head">
          <div class="popup-title">选择中心</div>
          <van-icon name="cross" class="popup-close" @click="departmentPicker.show = false" />
        </div>
        <div class="owner-dept-scroll">
          <van-loading v-if="departmentPicker.loading" class="panel-loading" size="20px" />
          <van-empty v-else-if="!topDepartmentOptions.length" description="暂无中心" class="panel-empty" />
          <van-checkbox-group v-else v-model="formPopup.form.departmentIds">
            <van-cell-group inset>
              <van-cell
                v-for="opt in topDepartmentOptions"
                :key="`project-dept-${opt.value}`"
                clickable
                :title="opt.text"
                @click="toggleDepartment(opt.value)"
              >
                <template #right-icon>
                  <van-checkbox :name="String(opt.value)" @click.stop />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
        <div class="owner-dept-actions">
          <van-button round block type="primary" class="theme-btn" @click="departmentPicker.show = false">完成</van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="picker.show" position="bottom">
      <van-picker
        show-toolbar
        :title="picker.title"
        :columns="picker.columns"
        @confirm="onPickerConfirm"
        @cancel="picker.show = false"
      />
    </van-popup>

    <van-popup v-model="datePicker.show" position="bottom">
      <van-datetime-picker
        type="date"
        :title="datePicker.title"
        :value="datePicker.value"
        @confirm="onConfirmDate"
        @cancel="datePicker.show = false"
      />
    </van-popup>

    <div class="page-bottom-bar">
      <van-button type="primary" block round class="theme-btn" @click="openCreate">新增项目</van-button>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import { fetchProjectList, createProject, updateProject, deleteProject } from "@/api/project"
import { fetchTopDepartments } from "@/api/customer"
import {
  resolveProjectRows,
  normalizeProjectDepartmentIds,
  formatProjectDepartmentNames,
  buildProjectQueryPayload
} from "@/utils/project"

const VALID_ONLY_TABS = [
  { label: "全部", value: "all" },
  { label: "有效期内", value: "valid" },
  { label: "已过期", value: "invalid" }
]

function formatDateOnly(date) {
  const dt = date instanceof Date ? date : new Date(date)
  const y = dt.getFullYear()
  const m = String(dt.getMonth() + 1).padStart(2, "0")
  const d = String(dt.getDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}

function createEmptyForm() {
  return {
    id: null,
    name: "",
    startDate: "",
    endDate: "",
    departmentIds: [],
    remark: ""
  }
}

export default {
  name: "ProjectManage",
  data() {
    return {
      loading: false,
      refreshing: false,
      items: [],
      topDepartmentOptions: [],
      filters: {
        name: "",
        topDepartmentId: null,
        validOnly: null
      },
      validOnlyTab: "all",
      validOnlyTabs: VALID_ONLY_TABS,
      formPopup: {
        show: false,
        mode: "create",
        submitting: false,
        form: createEmptyForm()
      },
      departmentPicker: {
        show: false,
        loading: false
      },
      picker: {
        show: false,
        title: "",
        type: "",
        columns: []
      },
      datePicker: {
        show: false,
        target: "",
        title: "",
        value: new Date()
      },
      filterTimer: null
    }
  },
  computed: {
    filterDepartmentLabel() {
      const id = this.filters.topDepartmentId
      if (id === null || id === undefined || id === "") return ""
      const hit = this.topDepartmentOptions.find(x => String(x.value) === String(id))
      return hit ? hit.text : String(id)
    },
    formDepartmentLabel() {
      const ids = this.formPopup.form.departmentIds || []
      if (!ids.length) return ""
      return ids
        .map(id => {
          const hit = this.topDepartmentOptions.find(x => String(x.value) === String(id))
          return hit ? hit.text : String(id)
        })
        .filter(Boolean)
        .join("、")
    }
  },
  created() {
    this.loadTopDepartments()
    this.loadList()
  },
  beforeDestroy() {
    if (this.filterTimer) {
      clearTimeout(this.filterTimer)
      this.filterTimer = null
    }
  },
  methods: {
    formatDepartmentNames(row) {
      return formatProjectDepartmentNames(row, this.topDepartmentOptions)
    },
    validityTagText(row) {
      if (row?.validOnly === true || row?.validOnly === 1 || row?.validOnly === "1" || row?.inValidPeriod === true) {
        return "有效期内"
      }
      if (row?.validOnly === false || row?.validOnly === 0 || row?.validOnly === "0" || row?.inValidPeriod === false) {
        return "已过期"
      }
      const start = (row?.startDate || "").trim()
      const end = (row?.endDate || "").trim()
      if (!start && !end) return ""
      const today = formatDateOnly(new Date())
      if (start && today < start) return "未开始"
      if (end && today > end) return "已过期"
      return "有效期内"
    },
    validityTagClass(row) {
      const text = this.validityTagText(row)
      if (text === "有效期内") return "project-valid-tag--valid"
      if (text === "已过期") return "project-valid-tag--invalid"
      return "project-valid-tag--pending"
    },
    projectCardClass(row) {
      const text = this.validityTagText(row)
      if (text === "有效期内") return "card-approved"
      if (text === "已过期") return "card-rejected"
      if (text === "未开始") return "card-pending"
      return "card-cancel"
    },
    buildListPayload() {
      return buildProjectQueryPayload(this.filters)
    },
    async loadTopDepartments() {
      try {
        const res = await fetchTopDepartments()
        const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : []
        this.topDepartmentOptions = list
          .map(item => ({
            text: item.weName || item.name || "-",
            value: item.weId ?? item.id
          }))
          .filter(x => x.value !== null && x.value !== undefined && x.value !== "")
      } catch (e) {
        this.topDepartmentOptions = []
      }
    },
    async loadList() {
      this.loading = true
      try {
        const res = await fetchProjectList(this.buildListPayload())
        this.items = resolveProjectRows(res)
      } catch (e) {
        this.items = []
      } finally {
        this.loading = false
        this.refreshing = false
      }
    },
    onFilterChange() {
      this.loadList()
    },
    onFilterNameInput() {
      if (this.filterTimer) clearTimeout(this.filterTimer)
      this.filterTimer = setTimeout(() => {
        this.loadList()
      }, 300)
    },
    onValidOnlyTabChange(name) {
      if (name === "valid") this.filters.validOnly = true
      else if (name === "invalid") this.filters.validOnly = false
      else this.filters.validOnly = null
      this.loadList()
    },
    onRefresh() {
      this.refreshing = true
      this.loadList()
    },
    openFilterDepartmentPicker() {
      if (!this.topDepartmentOptions.length) return Toast.fail("暂无中心列表")
      this.picker.type = "filterDepartment"
      this.picker.title = "选择中心"
      this.picker.columns = [{ text: "全部中心", value: "" }, ...this.topDepartmentOptions]
      this.picker.show = true
    },
    clearFilterDepartment() {
      this.filters.topDepartmentId = null
      this.loadList()
    },
    onPickerConfirm(values, indexes) {
      const idx = Array.isArray(indexes) ? indexes[0] : indexes
      const col = this.picker.columns[idx]
      if (!col) {
        this.picker.show = false
        return
      }
      if (this.picker.type === "filterDepartment") {
        this.filters.topDepartmentId = col.value === "" ? null : col.value
        this.loadList()
      }
      this.picker.show = false
    },
    openCreate() {
      this.formPopup.mode = "create"
      this.formPopup.form = createEmptyForm()
      this.formPopup.show = true
    },
    openEdit(row) {
      if (!row) return
      this.formPopup.mode = "edit"
      this.formPopup.form = {
        id: row.id ?? null,
        name: (row.name || row.projectName || "").trim(),
        startDate: (row.startDate || "").trim(),
        endDate: (row.endDate || "").trim(),
        departmentIds: normalizeProjectDepartmentIds(row),
        remark: (row.remark || "").trim()
      }
      this.formPopup.show = true
    },
    openDatePicker(target) {
      this.datePicker.target = target
      this.datePicker.title = target === "startDate" ? "选择开始日期" : "选择结束日期"
      const raw = (this.formPopup.form[target] || "").trim()
      this.datePicker.value = raw ? new Date(String(raw).replace(/-/g, "/")) : new Date()
      this.datePicker.show = true
    },
    onConfirmDate(value) {
      const target = this.datePicker.target
      if (target) {
        this.formPopup.form[target] = formatDateOnly(value)
      }
      this.datePicker.show = false
    },
    async openDepartmentPicker() {
      if (!this.topDepartmentOptions.length) {
        this.departmentPicker.loading = true
        await this.loadTopDepartments()
        this.departmentPicker.loading = false
      }
      if (!this.topDepartmentOptions.length) return Toast.fail("暂无中心列表")
      this.departmentPicker.show = true
    },
    toggleDepartment(value) {
      const key = String(value)
      const ids = [...(this.formPopup.form.departmentIds || [])]
      const idx = ids.findIndex(x => String(x) === key)
      if (idx >= 0) ids.splice(idx, 1)
      else ids.push(key)
      this.formPopup.form.departmentIds = ids
    },
    buildSubmitPayload(form) {
      return {
        name: (form.name || "").trim(),
        remark: (form.remark || "").trim() || undefined,
        startDate: (form.startDate || "").trim(),
        endDate: (form.endDate || "").trim(),
        departmentIds: (Array.isArray(form.departmentIds) ? form.departmentIds : [])
          .filter(x => x !== null && x !== undefined && x !== "")
          .map(x => Number(x))
          .filter(x => Number.isFinite(x))
      }
    },
    async submitForm() {
      if (this.formPopup.submitting) return
      const form = this.formPopup.form
      const name = (form.name || "").trim()
      if (!name) return Toast.fail("请输入项目名称")
      const departmentIds = Array.isArray(form.departmentIds) ? form.departmentIds : []
      if (!departmentIds.length) return Toast.fail("请选择中心")
      const startDate = (form.startDate || "").trim()
      const endDate = (form.endDate || "").trim()
      if (!startDate) return Toast.fail("请选择开始日期")
      if (!endDate) return Toast.fail("请选择结束日期")
      if (startDate > endDate) return Toast.fail("开始日期不能晚于结束日期")
      const payload = this.buildSubmitPayload(form)
      this.formPopup.submitting = true
      try {
        if (this.formPopup.mode === "create") {
          await createProject(payload)
          Toast.success("新增成功")
        } else {
          if (!form.id) return Toast.fail("缺少项目ID")
          await updateProject({ ...payload, id: form.id })
          Toast.success("保存成功")
        }
        this.formPopup.show = false
        this.loadList()
      } finally {
        this.formPopup.submitting = false
      }
    },
    async onDelete(row) {
      const id = row?.id
      if (id === null || id === undefined || id === "") return Toast.fail("缺少项目ID")
      try {
        await Dialog.confirm({ title: "确认删除？", message: "删除后不可恢复" })
      } catch (e) {
        return
      }
      await deleteProject(id)
      Toast.success("删除成功")
      this.loadList()
    }
  }
}
</script>

<style scoped>
.project-page {
  min-height: 100vh;
  background: #f5f6f8;
  padding-bottom: calc(var(--app-tabbar-offset) + 72px);
}

.project-top {
  position: sticky;
  top: 0;
  z-index: 1200;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.date-filter {
  padding: 0 12px 4px;
  background: #fff;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 24px;
  padding: 0 2px;
}

.date-label {
  font-size: 13px;
  color: #969799;
  flex-shrink: 0;
}

.date-value {
  color: #323233;
  font-size: 13px;
  padding: 1px 5px;
  border-radius: 6px;
  background: #f7f8fa;
}

.date-value--wide {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date-clear {
  margin-left: 6px;
  font-size: 12px;
  color: rgb(242, 124, 52);
  flex-shrink: 0;
}

.project-valid-tabs {
  padding: 0 8px;
}

:deep(.van-tab--active) {
  color: rgb(242, 124, 52);
}

:deep(.van-tabs__line) {
  background: rgb(242, 124, 52);
}

:deep(.van-tabs__wrap) {
  height: 34px;
}

.project-list {
  padding-top: 8px;
}

.records-wrap {
  padding: 0 12px 12px;
}

.record-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(30, 35, 90, 0.05);
}

.project-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.project-name {
  font-size: 15px;
  font-weight: 700;
  color: #323233;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-valid-tag {
  flex-shrink: 0;
}

.project-valid-tag--valid {
  color: #07c160;
  background: rgba(7, 193, 96, 0.08);
}

.project-valid-tag--invalid {
  color: #ee0a24;
  background: rgba(238, 10, 36, 0.08);
}

.project-valid-tag--pending {
  color: #ff976a;
  background: rgba(255, 151, 106, 0.1);
}

.project-row {
  font-size: 13px;
  color: #646566;
  line-height: 1.5;
}

.project-row--meta {
  margin-top: 4px;
  color: #969799;
  font-size: 12px;
}

.project-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.project-op-btn {
  flex: 1;
  min-width: 60px;
  height: 26px;
  line-height: 24px;
  font-size: 12px;
}

.project-op-btn--edit {
  color: #f27c34;
  border-color: rgba(242, 124, 52, 0.45);
  background: rgba(242, 124, 52, 0.08);
}

.project-op-btn--delete {
  color: #d65d8c;
  border-color: rgba(214, 93, 140, 0.45);
  background: rgba(214, 93, 140, 0.08);
}

.page-bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--app-tabbar-offset);
  padding: 10px 16px 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.04);
}

.popup-wrap,
.booking-popup-wrap,
.owner-dept-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 10px;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.popup-body,
.booking-popup-scroll,
.owner-dept-scroll {
  flex: 1;
  overflow-y: auto;
}

.popup-actions,
.owner-dept-actions {
  padding: 12px 16px 16px;
}

.theme-btn {
  background: rgb(242, 124, 52);
  border-color: rgb(242, 124, 52);
}

.panel-loading,
.panel-empty,
.empty {
  padding: 48px 0;
}
</style>

<style src="@/styles/approval-status.css"></style>
